module.exports = __webpack_public_path__ + "img/w3_grid_white.95dd1016.png";